import { GetSignInOptions } from '../analytics-context-types';
import { getModalTag, getPODProductTag } from './utils';

export const getSignIn = (options: GetSignInOptions) => {
  const startFlowModalEvent = [
    {
      eventInfo: {
        eventName: 'area',
        eventAction: options.elementPosition,
      },
    },
    {
      eventInfo: {
        eventName: 'sign in',
        eventAction: options.eventAction,
      },
    },
  ];

  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  const { modal } = getModalTag(options.productType, 'Preview Mode', startFlowModalEvent, options.projectID);

  return {
    modal,
    product,
  };
};
